import { createHashHistory, createBrowserHistory } from "history";

export class Navigate {

  static hashHistory = createHashHistory();

  static history = createBrowserHistory();

  static get route() {
    
    // if (AppConfig.routeMode === 'hash') {
      return this.hashHistory;
    // } else {
    //   return this.history;
    // }
  }
}